// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tool-box[data-v-f8fa6e6e]{\n   /* background: #d9d9d9;\n   color: #FFF; */\n   font-size: 16px;\n   font-style: normal;\n   font-weight: 700;\n   line-height: normal;\n}\n.active[data-v-f8fa6e6e]{\n   background: #BF5B5B;\n}\n", ""]);
// Exports
module.exports = exports;
